const data = {
	"google_cal": "",
	"streamers": [
		{
			"name": "Arcadd",
			"bio": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus non risus sapien. Aliquam laoreet turpis quam, id convallis ipsum convallis eget. Duis efficitur tincidunt elit porta rutrum. Donec laoreet orci magna, sit amet molestie neque ultricies et. Cras ultrices sapien nec mi finibus, eu condimentum dui porta.",
			"twitch_id": "40787504",
			"twitch_url": "https://twitch.tv/arcadd",
			"image": "/images/arcadd.jpg",
			"links": [
				{
					"name": "website",
					"url": "https://arcadd.tv/"
				},
				{
					"name": "twitter",
					"url": "https://twitter.com/arcaddtv"
				},
				{
					"name": "instagram",
					"url": "https://instagram.com/arcadd"
				}
			]
		},
		{
			"name": "Ryanemzed",
			"bio": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus non risus sapien. Aliquam laoreet turpis quam, id convallis ipsum convallis eget. Duis efficitur tincidunt elit porta rutrum. Donec laoreet orci magna, sit amet molestie neque ultricies et. Cras ultrices sapien nec mi finibus, eu condimentum dui porta.",
			"twitch_id": "86627776",
			"twitch_url": "https://twitch.tv/ryanemzed",
			"image": "/images/ryanemzed.jpg",
			"links": [
				{
					"name": "twitter",
					"url": "https://twitter.com/ryanemzed"
				},
				{
					"name": "instagram",
					"url": "https://instagram.com/ryanemzed"
				}
			]
		}
	],
	"discord": {
		"join_text": "Become a member & join our discord",
		"join_url": ""
	},
	"about": {
		"title": "about us",
		"text": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus non risus sapien. Aliquam laoreet turpis quam, id convallis ipsum convallis eget. Duis efficitur tincidunt elit porta rutrum. Donec laoreet orci magna, sit amet molestie neque ultricies et. Cras ultrices sapien nec mi finibus, eu condimentum dui porta."
	}
}

export default data;



// WEBPACK FOOTER //
// ./src/data.js